import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import {
  AppBrowserModule,
  preserveAgrSessionSnapshot,
  setupRuntimeConfig,
} from './app/app.browser.module';
import { environment } from './environments/environment';

const bootstrap = async (): Promise<void> => {
  if (environment.PRODUCTION) {
    enableProdMode();
  }
  preserveAgrSessionSnapshot();

  await setupRuntimeConfig;
  await platformBrowser().bootstrapModule(AppBrowserModule);
};

void bootstrap();
